@let currentTab = $currentTab();
<div class="flex flex-wrap justify-center items-center bg-[var(--panel-bg)]"
  [class.flex-col]="$position() === 'vertical'" [class.horizontal]="$position() === 'horizontal'"
  [class.vertical]="$position() === 'vertical'" [class.left-right-borders]="$leftRightBorders()"
  [class.top-bottom-borders]="$topBottomBorders()" [style.borderRadius]="$borderRadius() | cssValue">
  @for(tabItem of $items(); track tabItem) {
  <div class="relative button-container flex-grow basis-auto px-1" [class.w-full]="$position() === 'vertical'"
    [style]="(($index !== 0 ? '' : $firstColumnBorderRadius()) + ' ' + ($items().length !== 1 && $index !== $items().length - 1 ? '' : $lastColumnBorderRadius()) | cssValue)">
    @if (tabItem === currentTab && $activeIndicator() === 'border') {
    <span class="active-border active-border--top"></span>
    }
    <span class="w-full relative flex justify-center"
      [class.bg-neuter]="$inactiveBackground() && currentTab !== null && tabItem !== currentTab">
      @let tooltipWhenDisabled = (tabItem.tooltipWhenDisabled | asSignal)() ?? '';
      <app-button hostWidth="100%" gap="--gap-small" innerPadding="--padding-small" iconPosition="left"
        [textWeight]="$textWeight()" [activeIndicator]="$activeIndicator() === 'dot'"
        [activeIndicatorColor]="tabItem === $currentTab() ? '--secondary' : '--transparent'"
        [icon]="tabItem.icon ?? null" [iconColor]="tabItem.disabled !== true ? $iconsColor() : '--gray-thick'"
        [iconScale]="tabItem.iconScale ?? 1" [text]="(tabItem.text | asSignal)() ?? null" [ariaRoleDescription]="'css'"
        [disabled]="tabItem.disabled ?? false" [tooltipWhenDisabled]="tooltipWhenDisabled"
        (click)="tabClicked(tabItem)" />
    </span>
    @if (tabItem === currentTab && $position() === 'vertical' && $activeIndicator() === 'border') {
    <span class="active-border active-border--bottom"></span>
    }
  </div>
  }
</div>
